import {GiWinterHat} from "react-icons/gi";
import {BsFillHouseGearFill} from "react-icons/bs";
import {GiReceiveMoney} from "react-icons/gi";
import { FiGithub } from "react-icons/fi";
import {GiWoodCabin} from "react-icons/gi";
import {IoIosPeople} from "react-icons/io";
import {GiRose} from "react-icons/gi";
import {GiCutLemon} from "react-icons/gi";
import { PiShoppingCartFill } from "react-icons/pi";
import { PiStudentBold } from "react-icons/pi";
import { TbBuildingBank } from "react-icons/tb";
import { MdOutlineSpeakerPhone } from "react-icons/md";

export const data = [
  {
    id: 1,
    title: "Work Wave Hub",
    type: "full-stack",
    video: "/assets/videos_projects/wwh.mp4",
    icon: <IoIosPeople></IoIosPeople>,
    urlDemo: "https://workwavehub-jobs-platform.onrender.com",
    urlGit: "https://github.com/mdcodelab/WorkWaveHub-jobs-platform-MERN",
    description:
      "The app empowers users to create, read, update, delete their job listings or search for new jobs based on various criteria. It has full and secure authentication with JWT and HTTP cookies, that enables users to login or register and manage their profiles. There is an admin functionality to manage jobs and users.",
    tech: ["MERN", "JWT", "STYLED-COMPONENTS"],
  },
  {
    id: 2,
    title: "ProShop",
    type: "full-stack",
    video: "/assets/videos_projects/proshop.mp4",
    icon: <PiShoppingCartFill></PiShoppingCartFill>,
    urlDemo: "https://proshop-electronics.onrender.com",
    urlGit: "https://github.com/mdcodelab/ProShop-E-commerce-platform-mern",
    description:
      "In this e-commerce app, users can browse and search products, add them to their shopping cart, and then go throughout a four steps checkout process to create an order and then pay using PayPal. There is full authentication: users ca register or log in and they can manage their profiles and view their orders. There is also admin functionality where admins can manage products, orders and users, as well as a rating and review system.",
    tech: ["MERN", "REDUX", "JWT", "BOOTSTRAP"],
  },

  {
    id: 3,
    title: "Financial Management Test",
    type: "full-stack",
    video: "/assets/videos_projects/test.mp4",
    icon: <PiStudentBold></PiStudentBold>,
    urlDemo: "https://financial-management-test.vercel.app/",
    urlGit: "https://github.com/mdcodelab/student_tast-v2-clerk",
    description:
      "This application consists of a test for students in the “Financial Management” course. After registering/logging in, students are invited to complete the multiple-choice test and submit it. The final result and scores for each question will be available two hours after registration/login. The admin functionality allows the professor to record the results obtained by all students.",
    tech: ["NEXT.js", "MONGODB", "SHADCN/UI", "TAILWIND", "CLERK"],
  },

  {
    id: 4,
    title: "Bookit",
    type: "full-stack",
    video: "/assets/videos_projects/bookit.mp4",
    icon: <TbBuildingBank></TbBuildingBank>,
    urlDemo: "https://bookit-app-black.vercel.app/",
    urlGit: "https://github.com/mdcodelab/bookit-mern-app",
    description:
      "A web app for booking conference rooms with admin features and custom authentication. Users can browse available rooms, view details, and make reservations. Admins can create new rooms and manage existing ones.",
    tech: ["NEXT.js", "MONGODB", "JWT", "TAILWIND CSS"],
  },

  {
    id: 5,
    title: "Love Roses",
    type: "front-end",
    video: "/assets/videos_projects/roses.mp4",
    icon: <GiRose></GiRose>,
    urlDemo: "https://roses-store-webpage.vercel.app/",
    urlGit: "https://github.com/mdcodelab/roses-store-ecommerce-website",
    description:
      "LoveRoses is a dedicated online platform specializing in the sale of luxury roses and related accessories. It provides an interface for searching and purchasing products.",
    tech: ["REACT.js", "CSS3", "STYLED-COMPONENTS", "AOS", "TILT.js"],
  },
  {
    id: 6,
    title: "Wooden Wonders",
    type: "front-end",
    video: "/assets/videos_projects/wooden.mp4",
    icon: <GiWoodCabin></GiWoodCabin>,
    urlDemo: "https://glistening-tartufo-8aa482.netlify.app/",
    urlGit: "https://github.com/mdcodelab/e-commerce-react-website--frontend",
    description:
      "This e-commerce platform built with React and Netlify functions as a serverless backend provides a simple and intuitive user interface for searching products based on various criteria and purchasing products online.",
    tech: ["REACT.js", "CSS3", "AOS", "AUTH0", "STRIPE"],
  },
  {
    id: 7,
    title: "GitHub Finder",
    type: "w",
    video: "/assets/videos_projects/git.mp4",
    icon: <FiGithub></FiGithub>,
    urlDemo: "https://github-finder-react-eqfqo63wv-mdcodelab.vercel.app/",
    urlGit: "https://github.com/mdcodelab/github-finder-react-app",
    description:
      "This app utilizes the GitHub APIs and a search functionality to retrieve and display relevant information about users profiles and repositories.",
    tech: ["REACT.js", "CSS3"],
  },
  {
    id: 8,
    title: "The Recipes Room",
    type: "front-end",
    video: "/assets/videos_projects/recipes.mp4",
    icon: <GiCutLemon></GiCutLemon>,
    urlDemo: "https://the-recipes-room.netlify.app/recipes/",
    urlGit: "https://github.com/mdcodelab/gatsby-recipes-app",
    description:
      "This website aims to provide visitors a user-friendly platform for discovering, and managing culinary recipes. Key features include: intuitive interface, efficient categorization, responsiveness across all devices, detailed ingredients and cooking instructions.",
    tech: ["GATSBY", "GRAPHQL", "STYLED-COMPONENTS", "CONTENTFUL"],
  },
  {
    id: 9,
    title: "NPV & Risk Assessment",
    type: "w",
    video: "/assets/videos_projects/npv.mp4",
    icon: <GiReceiveMoney></GiReceiveMoney>,
    urlDemo: "https://npv-monte-carlo-risk-simulation-app.vercel.app/",
    urlGit: "https://github.com/mdcodelab/npv-monte-carlo-risk-simulation-app",
    description:
      "This app evaluates the net present value (NPV) of an investment project and assesses its risk based on Monte Carlo simulation. It displays the NPV under the most likely scenario associated with the investment based on the data from the user, but also evaluates the investment risk by estimating the mean NPV and the probability of the NPV > 0.",
    tech: ["JavaScript", "CSS3", "HTML5"],
  },
  {
  id: 10,
  title: "DIGI Chat Bot",
  type: "l",
  video: "/assets/videos_projects/digi.mp4",
  icon: <MdOutlineSpeakerPhone></MdOutlineSpeakerPhone>,
  urlDemo: "https://digi-chat-bot.onrender.com/",
  urlGit: "https://github.com/mdcodelab/chat-app-landing-page",
  description:
    "An animated landing page for an AI-powered chatbot, built for smooth and responsive interaction, designed to provide a fluid and interactive experience.",
  tech: ["REACT.js", "CSS3", "AOS"],
},
  {
    id: 11,
    title: "Architect Design",
    type: "l",
    video: "/assets/videos_projects/designer.mp4",
    icon: <BsFillHouseGearFill></BsFillHouseGearFill>,
    urlDemo: "https://interior-design-com.netlify.app/",
    urlGit: "https://github.com/mdcodelab/design-interior-website",
    description:
      "Responsive website with animations, including tilt.js. Customers can consult the services offered by the company regarding the desired architecture of their living space.",
    tech: ["JavaScript", "CSS3", "TILT.js", "HTML5"],
  },
  {
    id: 12,
    title: "Winter Landing Page",
    type: "l",
    video: "/assets/videos_projects/winter.mp4",
    icon: <GiWinterHat></GiWinterHat>,
    urlDemo: "https://winter-beauties.netlify.app/",
    urlGit: "https://github.com/mdcodelab/winterscape-landingpage",
    description:
      "Winterscape - a virtual snowfall experience with audio and animations. Users are invited to buy products, read recipes and news, all for the winter season!",
    tech: ["JavaScript", "CSS3", "HTML5"],
  },
];
